var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44335 7.93556L0.14647 6.64649C-0.0488424 6.45118 -0.0488424 6.13087 0.14647 5.93555L5.94335 0.146485C6.13866 -0.0488282 6.45116 -0.0488282 6.64648 0.146485L12.4434 5.93555C12.6387 6.13087 12.6387 6.45118 12.4434 6.64649L11.1465 7.93556C10.9512 8.13087 10.6387 8.13087 10.4434 7.93556L6.29491 3.78711L2.14647 7.93556C1.95116 8.13087 1.63866 8.13087 1.44335 7.93556Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/Arrow-up.b6da28997f73f225bbd3eb1eb4857db9.svg";
export { ForwardRef as ReactComponent };